var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7151 51.0068H52.2887L51.7832 50.5193C53.9498 47.9915 55.0693 44.5429 54.4554 40.8776C53.6068 35.8582 49.4179 31.8498 44.3623 31.2359C36.7248 30.297 30.297 36.7248 31.2359 44.3623C31.8498 49.4179 35.8582 53.6068 40.8776 54.4554C44.5429 55.0693 47.9915 53.9498 50.5193 51.7832L51.0068 52.2887V53.7151L58.6804 61.3887C59.4207 62.129 60.6304 62.129 61.3707 61.3887C62.1109 60.6484 62.1109 59.4387 61.3707 58.6984L53.7151 51.0068ZM42.8818 51.0068C38.3859 51.0068 34.7568 47.3776 34.7568 42.8818C34.7568 38.3859 38.3859 34.7568 42.8818 34.7568C47.3776 34.7568 51.0068 38.3859 51.0068 42.8818C51.0068 47.3776 47.3776 51.0068 42.8818 51.0068Z",
    fill: "#FBD207"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7751 36.5441C57.0348 36.6498 56.3579 36.1307 56.1594 35.4096C54.9796 31.1245 51.274 28.3837 47.1411 27.3258C46.4166 27.1403 45.9161 26.4485 46.039 25.7107C46.162 24.973 46.861 24.4697 47.5875 24.6473C52.5587 25.8624 57.4479 29.2696 58.859 35.0231C59.0372 35.7494 58.5155 36.4383 57.7751 36.5441Z",
    fill: "#FBD207"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0818 49.7906C27.8096 49.6184 28.5315 50.0735 28.7836 50.7777C30.3168 55.0597 34.0482 57.6525 38.3963 58.0969C39.1403 58.1729 39.7485 58.7716 39.7485 59.5195C39.7485 60.2674 39.1408 60.8798 38.3957 60.8163C32.9047 60.3478 28.0112 57.0275 26.1342 51.405C25.8973 50.6956 26.354 49.9628 27.0818 49.7906Z",
    fill: "#FBD207"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 12,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8327 17.832V11.4987C34.8327 9.75703 33.4077 8.33203 31.666 8.33203H6.33268C4.59102 8.33203 3.18185 9.75703 3.18185 11.4987V17.832C4.92352 17.832 6.33268 19.257 6.33268 20.9987C6.33268 22.7404 4.92352 24.1654 3.16602 24.1654V30.4987C3.16602 32.2404 4.59102 33.6654 6.33268 33.6654H31.666C33.4077 33.6654 34.8327 32.2404 34.8327 30.4987V24.1654C33.091 24.1654 31.666 22.7404 31.666 20.9987C31.666 19.257 33.091 17.832 34.8327 17.832ZM31.666 15.5204C29.7819 16.6129 28.4994 18.6712 28.4994 20.9987C28.4994 23.3262 29.7819 25.3845 31.666 26.477V30.4987H6.33268V26.477C8.21685 25.3845 9.49935 23.3262 9.49935 20.9987C9.49935 18.6554 8.23268 16.6129 6.34852 15.5204L6.33268 11.4987H31.666V15.5204ZM14.3602 27.332L18.9994 24.3554L23.6385 27.332L22.2294 22.012L26.4885 18.5287L20.9944 18.1962L18.9994 13.082L16.9885 18.1804L11.4944 18.5129L15.7535 21.9962L14.3602 27.332Z",
    fill: "#FBD207"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvents);
export default __webpack_public_path__ + "static/media/no_events.89bf95d5.svg";
export { ForwardRef as ReactComponent };